<template>
  <div class="SGroupSubList">
    <el-table
      :data="SurveyGroupData"
      style="width: 100%">
      <el-table-column
         type="index"
         label="Sr.No."
         width="100"
       >
      </el-table-column>
      <el-table-column
        prop="title"
        label="Survey Name"
         width="350"
        >
      </el-table-column>
      <el-table-column
        prop="startDate"
        label="Start Date">
      </el-table-column>
      <el-table-column
        prop="endDate"
        label="End Date">
      </el-table-column>
      <el-table-column
        prop="surveyType"
        label="Survey Type">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ['SurveyGroupData'],
  data () {
    return {
      tableData: [{
        id: '',
        title: '',
        startDate: ''
      }]
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SurveyGroup/SurveyGroupInfoTable.vue